"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HighlightTaskProperty = void 0;
var HighlightTaskProperty;
(function (HighlightTaskProperty) {
    HighlightTaskProperty["Priority"] = "PRIORITY";
    HighlightTaskProperty["Type"] = "TYPE";
    HighlightTaskProperty["Assignee"] = "ASSIGNEE";
    HighlightTaskProperty["Comments"] = "COMMENTS";
    HighlightTaskProperty["Description"] = "DESCRIPTION";
    HighlightTaskProperty["Status"] = "STATUS";
    HighlightTaskProperty["Flagged"] = "Flagged";
})(HighlightTaskProperty = exports.HighlightTaskProperty || (exports.HighlightTaskProperty = {}));
//# sourceMappingURL=task-highlights.js.map